import * as React from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "components/common";
import { useFetchDataAdapter } from "components/lookup-tables/hooks/useLookupTablesAPI";
import AdapterShow from "./adapter-show";
function AdapterView() {
  const { adapterIdOrName } = useParams();
  const { dataAdapter, loadingDataAdapter } = useFetchDataAdapter(adapterIdOrName);
  if (loadingDataAdapter) return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading data adapter details" });
  return /* @__PURE__ */ React.createElement(AdapterShow, { dataAdapter });
}
export default AdapterView;
